export const bundleData: any = {
    jp: [
        // 真实数据
        // 1. DELTA 2 Max
        {
            id: '7700809089185',
            variantId: '43020979863713',
            type: 3, //1 时间限定 2 数量限定 3 只有常规售卖阶段
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '15% OFF',
            offTips: '',
            name: 'DELTA 2 Max',
            tag: null,
            isEnd: false,
            img: '/media/delta2max/crowdfunding/pc/1.png',
            mobileImg: '/media/delta2max/crowdfunding/h5/1.png',
            include: [],
            delivery_date: '',
            // 0531上线去掉该文案
            // note: '5/31 23:59までにDELTA 2 MaxもしくはDELTA 2 Maxを含むセットをご購入のお客様全員に、もれなくEcoFlowオリジナルのキャリーカートをプレゼント！さらに、抽選で5名様に全額キャッシュバック！',
            sale: 0,
            count: null,
            // countdown: true
            discountPrice: 215990,
            originalPrice: 254100,
            price_suffix: '(税込)',
            sku: 'EFDELTA2Max-JP',
            node: 'product-component-1683699042904',
            buyLink: 'https://jp.ecoflow.com/products/delta-2-max-portable-power-station',
        },

        // 2. DELTA 2 Max + DELTA 2 Max専用エクストラバッテリー
        {
            id: '7700831043745',
            variantId: '43021111689377',
            type: 3, //1 时间限定 2 数量限定 3 只有常规售卖阶段
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '25% OFF',
            offTips: '',
            name: 'DELTA 2 Max + DELTA 2 Max専用エクストラバッテリー',
            tag: null,
            isEnd: false,
            img: '/media/delta2max/crowdfunding/pc/2.png',
            mobileImg: '/media/delta2max/crowdfunding/h5/2.png',
            include: [],
            delivery_date: '',
            // 0531上线去掉该文案
            // note: '5/31 23:59までにDELTA 2 MaxもしくはDELTA 2 Maxを含むセットをご購入のお客様全員に、もれなくEcoFlowオリジナルのキャリーカートをプレゼント！さらに、抽選で5名様に全額キャッシュバック！',
            sale: 0,
            count: null,
            // countdown: true
            discountPrice: 293700,
            originalPrice: 391600,
            price_suffix: '(税込)',
            sku: 'EFDELTA2Max-JP-EFDELTA2MaxEB',
            node: 'product-component-1683698641471',
            buyLink: 'https://jp.ecoflow.com/products/delta-2-max-extra-battery-bundle',
        },

        // 3. DELTA 2 Max + WAVE 2 ポータブルエアコン + GLACIER ポータブル冷蔵庫
        {
            id: '7703211507873',
            variantId: '43028352958625',
            type: 3, //1 时间限定 2 数量限定 3 只有常规售卖阶段
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '25% OFF',
            offTips: '',
            name: 'DELTA 2 Max + WAVE 2 ポータブルエアコン + GLACIER ポータブル冷蔵庫 ',
            tag: 'おすすめセット',
            isEnd: false,
            img: '/media/delta2max/crowdfunding/pc/3.png',
            mobileImg: '/media/delta2max/crowdfunding/h5/3.png',
            include: [],
            delivery_date: '',
            // 0531上线去掉该文案
            // note: '5/31 23:59までにDELTA 2 MaxもしくはDELTA 2 Maxを含むセットをご購入のお客様全員に、もれなくEcoFlowオリジナルのキャリーカートをプレゼント！さらに、抽選で5名様に全額キャッシュバック！',
            sale: 0,
            count: null,
            // countdown: true
            discountPrice: 379340,
            originalPrice: 505780,
            price_suffix: '(税込)',
            sku: 'EFDELTA2Max-ZYDKT210-ZYDBX100-LXT150-1m-JP',
            node: 'product-component-1684209267852',
            buyLink: 'https://jp.ecoflow.com/products/delta-2-max-wave-2-glacier-bundle',
        },

        // 4. DELTA 2 Max + WAVE 2 ポータブルエアコン
        {
            id: '7700842676385',
            variantId: '43021144260769',
            type: 3, //1 时间限定 2 数量限定 3 只有常规售卖阶段
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '25% OFF',
            offTips: '',
            name: 'DELTA 2 Max + WAVE 2 ポータブルエアコン',
            tag: null,
            isEnd: false,
            img: '/media/delta2max/crowdfunding/pc/4.png',
            mobileImg: '/media/delta2max/crowdfunding/h5/4.png',
            include: [],
            delivery_date: '',
            // 0531上线去掉该文案
            // note: '5/31 23:59までにDELTA 2 MaxもしくはDELTA 2 Maxを含むセットをご購入のお客様全員に、もれなくEcoFlowオリジナルのキャリーカートをプレゼント！さらに、抽選で5名様に全額キャッシュバック！',
            sale: 0,
            count: null,
            // countdown: true
            discountPrice: 288920,
            originalPrice: 385220,
            price_suffix: '(税込)',
            sku: 'EFDELTA2Max-ZYDKT210-LXT150-1m-JP',
            node: 'product-component-1683703874486',
            buyLink: 'https://jp.ecoflow.com/products/delta-2-max-wave-2-portable-air-conditioner-bundle',
        },

        // 5. DELTA 2 Max + GLACIER ポータブル冷蔵庫
        {
            id: '7700848246945',
            variantId: '43021158711457',
            type: 3, //1 时间限定 2 数量限定 3 只有常规售卖阶段
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '15% OFF',
            offTips: '',
            name: 'DELTA 2 Max + GLACIER ポータブル冷蔵庫',
            tag: null,
            isEnd: false,
            img: '/media/delta2max/crowdfunding/pc/5.png',
            mobileImg: '/media/delta2max/crowdfunding/h5/5.png',
            include: [],
            delivery_date: '',
            // 0531上线去掉该文案
            // note: '5/31 23:59までにDELTA 2 MaxもしくはDELTA 2 Maxを含むセットをご購入のお客様全員に、もれなくEcoFlowオリジナルのキャリーカートをプレゼント！さらに、抽選で5名様に全額キャッシュバック！',
            sale: 0,
            count: null,
            // countdown: true
            discountPrice: 312010,
            originalPrice: 367070,
            price_suffix: '(税込)',
            sku: 'EFDELTA2Max-ZYDBX100-ZYDBX100-EB-JP',
            node: 'product-component-1683706534398',
            buyLink: 'https://jp.ecoflow.com/products/delta-2-max-glacier-portable-refrigerator-extra-battery',
        },

        // 6. DELTA 2 Max + 220W両面受光型ソーラーパネル
        {
            id: '7700834025633',
            variantId: '43021123387553',
            type: 3, //1 时间限定 2 数量限定 3 只有常规售卖阶段
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '25% OFF',
            offTips: '',
            name: 'DELTA 2 Max + 220W両面受光型ソーラーパネル',
            tag: null,
            isEnd: false,
            img: '/media/delta2max/crowdfunding/pc/6.png',
            mobileImg: '/media/delta2max/crowdfunding/h5/6.png',
            include: [],
            delivery_date: '',
            // 0531上线去掉该文案
            // note: '5/31 23:59までにDELTA 2 MaxもしくはDELTA 2 Maxを含むセットをご購入のお客様全員に、もれなくEcoFlowオリジナルのキャリーカートをプレゼント！さらに、抽選で5名様に全額キャッシュバック！',
            sale: 0,
            count: null,
            // countdown: true
            discountPrice: 235290,
            originalPrice: 313720,
            price_suffix: '(税込)',
            sku: '',
            node: 'product-component-1683702383010',
            buyLink: 'https://jp.ecoflow.com/products/delta-2-max-portable-power-station-220w-solar-panel',
        },

        // 7. DELTA 2 Max + 400Wソーラーパネル
        {
            id: '7700838776993',
            variantId: '43021137805473',
            type: 3, //1 时间限定 2 数量限定 3 只有常规售卖阶段
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '25% OFF',
            offTips: '',
            name: 'DELTA 2 Max + 400Wソーラーパネル',
            tag: null,
            isEnd: false,
            img: '/media/delta2max/crowdfunding/pc/7.png',
            mobileImg: '/media/delta2max/crowdfunding/h5/7.png',
            include: [],
            delivery_date: '',
            // 0531上线去掉该文案
            // note: '5/31 23:59までにDELTA 2 MaxもしくはDELTA 2 Maxを含むセットをご購入のお客様全員に、もれなくEcoFlowオリジナルのキャリーカートをプレゼント！さらに、抽選で5名様に全額キャッシュバック！',
            sale: 0,
            count: null,
            // countdown: true
            discountPrice: 276870,
            originalPrice: 369160,
            price_suffix: '(税込)',
            sku: 'EFDELTA2Max-SOLAR400W-1-JP',
            node: 'product-component-1683702645951',
            buyLink: 'https://jp.ecoflow.com/products/delta-2-max-portable-power-station-400w-solar-panel',
        },

        // 8. DELTA 2 Max + DELTA 2 Max専用エクストラバッテリー + 220W両面受光型ソーラーパネル
        {
            id: '7700840153249',
            variantId: '43021141508257',
            type: 3, //1 时间限定 2 数量限定 3 只有常规售卖阶段
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '30% OFF',
            offTips: '',
            name: 'DELTA 2 Max + DELTA 2 Max専用エクストラバッテリー + 220W両面受光型ソーラーパネル',
            tag: null,
            isEnd: false,
            img: '/media/delta2max/crowdfunding/pc/8.png',
            mobileImg: '/media/delta2max/crowdfunding/h5/8.png',
            include: [],
            delivery_date: '',
            // 0531上线去掉该文案
            // note: '5/31 23:59までにDELTA 2 MaxもしくはDELTA 2 Maxを含むセットをご購入のお客様全員に、もれなくEcoFlowオリジナルのキャリーカートをプレゼント！さらに、抽選で5名様に全額キャッシュバック！',
            sale: 0,
            count: null,
            // countdown: true
            discountPrice: 321170,
            originalPrice: 458810,
            price_suffix: '(税込)',
            sku: 'EFDELTA2Max-EFDELTA2Max-EB-Solar220W-1-JP',
            node: 'product-component-1683702945525',
            buyLink: 'https://jp.ecoflow.com/products/delta-2-max-extra-battery-220w-solar-panel-bundle',
        },

        // 9. DELTA 2 Max + WAVE 2 ポータブルエアコン + WAVE 2 専用バッテリーパック
        {
            id: '7700843528353',
            variantId: '43021148192929',
            type: 3, //1 时间限定 2 数量限定 3 只有常规售卖阶段
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '30% OFF',
            offTips: '',
            name: 'DELTA 2 Max + WAVE 2 ポータブルエアコン + WAVE 2 専用バッテリーパック',
            tag: null,
            isEnd: false,
            img: '/media/delta2max/crowdfunding/pc/9.png',
            mobileImg: '/media/delta2max/crowdfunding/h5/9.png',
            include: [],
            delivery_date: '',
            // 0531上线去掉该文案
            // note: '5/31 23:59までにDELTA 2 MaxもしくはDELTA 2 Maxを含むセットをご購入のお客様全員に、もれなくEcoFlowオリジナルのキャリーカートをプレゼント！さらに、抽選で5名様に全額キャッシュバック！',
            sale: 0,
            count: null,
            // countdown: true
            discountPrice: 344340,
            originalPrice: 491920,
            price_suffix: '(税込)',
            sku: 'EFDELTA2Max-ZYDKT210-ZYDKT210-EB-LXT150-1m-JP',
            node: 'product-component-1683704949655',
            buyLink: 'https://jp.ecoflow.com/products/delta-2-max-wave-2-portable-air-conditioner-extra-battery-bundle',
        },

        // 10. DELTA 2 Max + WAVE 2 ポータブルエアコン + 400Wソーラーパネル
        {
            id: '7700845232289',
            variantId: '43021151371425',
            type: 3, //1 时间限定 2 数量限定 3 只有常规售卖阶段
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '30% OFF',
            offTips: '',
            name: 'DELTA 2 Max + WAVE 2 ポータブルエアコン + 400Wソーラーパネル',
            tag: null,
            isEnd: false,
            img: '/media/delta2max/crowdfunding/pc/10.png',
            mobileImg: '/media/delta2max/crowdfunding/h5/10.png',
            include: [],
            delivery_date: '',
            // 0531上线去掉该文案
            // note: '5/31 23:59までにDELTA 2 MaxもしくはDELTA 2 Maxを含むセットをご購入のお客様全員に、もれなくEcoFlowオリジナルのキャリーカートをプレゼント！さらに、抽選で5名様に全額キャッシュバック！',
            sale: 0,
            count: null,
            // countdown: true
            discountPrice: 355510,
            originalPrice: 507870,
            price_suffix: '(税込)',
            sku: 'EFDELTA2Max-ZYDKT210-SOLAR400W-1-LXT150-1m-JP',
            node: 'product-component-1683705435115',
            buyLink: 'https://jp.ecoflow.com/products/delta-2-max-wave-2-portable-air-conditioner-400w-solar-panel-bundle',
        },

        // // 11. DELTA 2 Max + GLACIER ポータブル冷蔵庫    0524 上线前删除
        // {
        //     id: '7700846510241',
        //     variantId: '43021156810913',
        //     type: 3, //1 时间限定 2 数量限定 3 只有常规售卖阶段
        //     stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
        //     ignore: true, // 无限库存
        //     off: '25% OFF',
        //     offTips: '',
        //     name: 'DELTA 2 Max + GLACIER ポータブル冷蔵庫',
        //     tag: null,
        //     isEnd: false,
        //     img: '/media/delta2max/crowdfunding/pc/11.png',
        //     mobileImg: '/media/delta2max/crowdfunding/h5/11.png',
        //     include: [],
        //     delivery_date: '',
        //     note: '5/31 23:59までにDELTA 2 MaxもしくはDELTA 2 Maxを含むセットをご購入のお客様全員に、もれなくEcoFlowオリジナルのキャリーカートをプレゼント！さらに、抽選で5名様に全額キャッシュバック！',
        //     sale: 0,
        //     count: null,
        //     // countdown: true
        //     discountPrice: 275300,
        //     originalPrice: 367070,
        //     price_suffix: '(税込)',
        //     sku: 'EFDELTA2Max-ZYDBX100-JP',
        //     node: 'product-component-1683706031443',
        //     buyLink: 'https://jp.ecoflow.com/products/delta-2-max-glacier-portable-refrigerator',
        // },

        // 12. DELTA 2 Max + GLACIER ポータブル冷蔵庫 + 220W両面受光型ソーラーパネル
        {
            id: '7700849229985',
            variantId: '43021160677537',
            type: 3, //1 时间限定 2 数量限定 3 只有常规售卖阶段
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '20% OFF',
            offTips: '',
            name: 'DELTA 2 Max + GLACIER ポータブル冷蔵庫 + 220W両面受光型ソーラーパネル',
            tag: null,
            isEnd: false,
            img: '/media/delta2max/crowdfunding/pc/12.png',
            mobileImg: '/media/delta2max/crowdfunding/h5/12.png',
            include: [],
            delivery_date: '',
            // 0531上线去掉该文案
            // note: '5/31 23:59までにDELTA 2 MaxもしくはDELTA 2 Maxを含むセットをご購入のお客様全員に、もれなくEcoFlowオリジナルのキャリーカートをプレゼント！さらに、抽選で5名様に全額キャッシュバック！',
            sale: 0,
            count: null,
            // countdown: true
            discountPrice: 347420,
            originalPrice: 434280,
            price_suffix: '(税込)',
            sku: 'EFDELTA2Max-ZYDBX100-Solar220W-1-JP',
            node: 'product-component-1683709765211',
            buyLink: 'https://jp.ecoflow.com/products/delta-2-max-glacier-portable-refrigerator-220w-solar-panel',
        },
    ],
};
